<template>
  <div>
    <p>Vee Validate Test</p>

    <h1>Vee Validate</h1>
    <section>
      <dl>
        <dt>Vee-Validate</dt>
        <dd>
          <validation-provider rules="required" v-slot="{errors}" name="項目">
            <label>
              必須項目
              <input type="text" v-model="required_value" />
            </label>
            <br />
            <span v-for="(error, key) in errors" :key="key">{{ error }}</span>
          </validation-provider>
        </dd>
      </dl>
    </section>
  </div>
</template>

<script>
export default {
  name: "VeeValidate",
  data: function() {
    return {
      required_value: null
    }
  }
}
</script>

<style scoped>
dl {
  border: solid 1px;
  padding: 16px;
}

dt {
  font-weight: bold;
}

dt:after {
  content: ":";
}

dd {
}

button {
  color: #fff;
  background: #8fbcbb;
  border: solid 1px #8fbcbb;
  border-radius: 4px;
  padding: 4px;
}
</style>
